import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { MaintenanceActivitiesImportModel } from 'src/app/models/imports/maintenance-activities-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { MaintenanceActivitiesModel } from 'src/app/models/maintenance/maintenance-activities-model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceActivitiesService {

  constructor(private _httpClient: HttpClient) { }

  createMaintenanceActivities(maintenanceActivitiesModel: MaintenanceActivitiesModel): Observable<MaintenanceActivitiesModel> {
    return this._httpClient.post<MaintenanceActivitiesModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.CreateAsync}`,
      maintenanceActivitiesModel);
  }

  deleteMaintenanceActivities(maintenanceActivitiesId: number): Observable<MaintenanceActivitiesModel> {
    return this._httpClient.delete<MaintenanceActivitiesModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.DeleteAsync}/${maintenanceActivitiesId}`);
  }

  deleteSomeDetails(maintenanceActivitiesIds: number[]): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.DeleteSomeDetailsAsync}`,
      maintenanceActivitiesIds);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getAllMaintenanceActivitiesWithPaginationAsync(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.GetAllMaintenanceActivitiesWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getMaintenanceActivityByCode(code: number): Observable<MaintenanceActivitiesModel> {
    return this._httpClient.get<MaintenanceActivitiesModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.GetByCodeAsync}/${code}`)
  }

  getMaintenanceActivityById(id: number): Observable<MaintenanceActivitiesModel> {
    return this._httpClient.get<MaintenanceActivitiesModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.GetByIdAsync}/${id}`);
  }

  getMaintenanceActivitiesById(maintenanceActivitiesId: number): Observable<MaintenanceActivitiesModel> {
    return this._httpClient.get<MaintenanceActivitiesModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.GetByIdAsync}/${maintenanceActivitiesId}`);
  }

  getColumnsForGeneralConsultationAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.GetColumnsForGeneralConsultationAsync}`);
  }

  getFirstMaintenanceActivitiesByKeysAsync(): Observable<MaintenanceActivitiesModel> {
    return this._httpClient.get<MaintenanceActivitiesModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.GetFirstMaintenanceActivitiesByKeysAsync}`,);
  }

  getLastMaintenanceActivitiesByKeysAsync(): Observable<MaintenanceActivitiesModel> {

    return this._httpClient.get<MaintenanceActivitiesModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.GetLastMaintenanceActivitiesByKeysAsync}`);
  }

  getNextMaintenanceActivitiesByKeysAsync(code: number): Observable<MaintenanceActivitiesModel> {
    const params = new HttpParams().set('code', code);
    return this._httpClient.get<MaintenanceActivitiesModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.GetNextMaintenanceActivitiesByKeysAsync}`,
      { params: params }
    );
  }

  getPreviusMaintenanceActivitiesByKeysAsync(code: number): Observable<MaintenanceActivitiesModel> {
    const params = new HttpParams().set('code', code);
    return this._httpClient.get<MaintenanceActivitiesModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.GetPreviusMaintenanceActivitiesByKeysAsync}`,
      { params: params }
    );
  }

  importMaintenanceActivities(maintenandeActivitiesImports: Array<MaintenanceActivitiesImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.ImportMaintenanceActivitiesAsync}`, maintenandeActivitiesImports
    );
  }

  updateMaintenanceActivities(maintenanceActivitiesModel: MaintenanceActivitiesModel): Observable<MaintenanceActivitiesModel> {
    return this._httpClient.put<MaintenanceActivitiesModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceActivities.UpdateAsync}`,
      maintenanceActivitiesModel);
  }

}
